import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: 'svg-container',
  templateUrl: './svg-container.component.html'
})
export class SvgContainerComponent implements OnInit {
  @Input() width:       string;
  @Input() height:      string;
  @Input() svg:         string;
           viewbox:     string;


  ngOnInit() {
    this.viewbox = `0 0 ${this.width} ${this.height}`;
  }

}
